<template>
  <div>
    <b-row class="mb-5">
      <b-col>
        <h5>Basisdaten</h5>
        <user-data :user=this.user :admin=true></user-data>
      </b-col>
    </b-row>

    <b-row class="mb-5">
      <b-col>
        <h5>Benutzer verschieben</h5>
        <find-school v-on:selected="this.selectSchool" horizontal></find-school>

        <b-form-group horizontal class="text-right">
          <b-button type="button" variant="primary" v-on:click="updateSchool" :disabled=buttonDisabled>Verschieben</b-button>
        </b-form-group>

      </b-col>
    </b-row>

    <b-row class="mb-5">
      <b-col>
        <h5>Benutzer löschen</h5>
        <div class="text-right">
          <b-button type="button" variant="danger" v-on:click="confirmDelete">Benutzer löschen</b-button>
        </div>

        <delete-modal ref="deleteModal" v-on:confirm="deleteUser"></delete-modal>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {User} from '@/models'
import UserData from '@/components/user/Form'
import FindSchool from '@/components/schools/FindSchool'
import DeleteModal from '@/components/user/DeleteModal'

export default {
  name: 'UsersDetails',
  components: {
    userData: UserData,
    findSchool: FindSchool,
    deleteModal: DeleteModal
  },
  data: function () {
    return {
      user: new User(),
      selectedSchool: null
    }
  },

  computed: {
    buttonDisabled: function () {
      return this.selectedSchool == null
    }
  },

  mounted: function () {
    if (this.$route.params.id) {
      this.user.id = this.$route.params.id
      this.user.fetch()
    }
  },

  methods: {
    confirmDelete: function () {
      this.$refs.deleteModal.show()
    },

    selectSchool: function (school) {
      this.selectedSchool = school
    },

    updateSchool: function () {
      this.axios.patch('/users/' + this.user.id + '/school', JSON.stringify({
        schoolId: this.selectedSchool.id
      }))
        .then(() => {
          this.$eventHub.$emit('info', 'Schule erfolgreich aktualisiert')
        })
    },

    deleteUser: function () {
      let that = this

      this.user.delete()
        .then(function () {
          that.$router.push({name: 'admin.users'})
          that.$eventHub.$emit('alertInfo', 'Benutzer erfolgreich gelöscht')
        })
        .catch(function (err) {
          that.$eventHub.$emit('alertError', err)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/users/Details.vue